import React from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Link from 'next/link';
import { getDictionary, getField } from '@/app/utils/translation/translation';

interface ProductCardProps {
    id: number;
    title: string;
    image: any;
    isMobile: any;
    link: string;
    href: string;
    comingSoon?: boolean;
    language: any, translations: any
}

const ProductCard: React.FC<ProductCardProps> = ({
    id,
    title,
    image,
    isMobile,
    link,
    href,
    comingSoon,
    language,
    translations
}) => {
    const dictionary = getDictionary(translations, 'navbar', language);
    const CardContentComponent = (
        <Card
            sx={{
                position: 'relative',
                borderRadius: '15px',
                maxWidth: isMobile ? 320 : 250,
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                cursor: comingSoon ? 'not-allowed' : 'pointer',
                backgroundColor: "var(--section-bg)",
            }}
        >
            {comingSoon && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 10,
                        left: 10,
                        backgroundColor: 'var(--accent-primary)',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '5px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        zIndex: 1,
                        fontFamily: 'Century Gothic',
                    }}
                >
                    {getField(dictionary, 'coming-soon', language)}
                </Box>
            )}
            <CardMedia component="img" alt={title} height="auto" image={image} />
            <CardContent>
                <Typography
                    gutterBottom
                    variant="h2"
                    component="h2"
                    textAlign="center"
                    sx={{ color: "var(--text-primary)" }}
                    fontWeight="bold"
                    fontFamily="Century Gothic"
                    fontSize="1rem"
                >
                    {title}
                </Typography>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography fontWeight="bold" color="var(--accent-primary)" fontSize="0.9rem">
                        {link}
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );

    return comingSoon ? (
        CardContentComponent
    ) : (
        <Link href={href} passHref legacyBehavior>
            <a style={{ textDecoration: 'none' }}>{CardContentComponent}</a>
        </Link>
    );
};

export default ProductCard;
